<div class="date-picker-wrapper">
    <form [formGroup]="minMaxDateSelectGroup">
        <div class="min-date">
            <hc-form-field>
                <input
                    hcInput
                    [hcDatepicker]="minPicker"
                    formControlName="selectedMinDateControl"
                    [max]="maxDate"
                    placeholder="Min"
                />
                <hc-datepicker-toggle hcSuffix [for]="minPicker"></hc-datepicker-toggle>
                <hc-datepicker #minPicker></hc-datepicker>
            </hc-form-field>
        </div>
    </form>
    <form [formGroup]="minMaxDateSelectGroup">
        <div class="max-date">
            <hc-form-field>
                <input
                    hcInput
                    [hcDatepicker]="maxPicker"
                    formControlName="selectedMaxDateControl"
                    [min]="minDate"
                    placeholder="Max"
                />
                <hc-datepicker-toggle hcSuffix [for]="maxPicker"></hc-datepicker-toggle>
                <hc-datepicker #maxPicker></hc-datepicker>
            </hc-form-field>
        </div>
    </form>
</div>
